// extracted by mini-css-extract-plugin
export var download = "algemenevoorwaarden-module--download--5cca0";
export var gebruikersVoorwaarden = "algemenevoorwaarden-module--gebruikers-voorwaarden--3f196";
export var homepagelink = "algemenevoorwaarden-module--homepagelink--88335";